module.exports = __webpack_public_path__ + "media/images/page/about01-a473427485e682b53b11d224d5445360.jpg";